import { getUserStatus, reduxEqualityFunction } from 'library/helpers/utility';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { PersonProfileCard } from 'zComponents/atoms';
import { Col, Input, Row, Table } from 'zui/Antd';
import ViewProfileCard from './components/ViewProfileCard';

const { Search } = Input;

const PeopleTableInformation = () => {
	const { data: peopleData, loading } = useSelector((state) => state.People, {
		equalityFn: reduxEqualityFunction
	});

	const [searchTerm, setSearchTerm] = useState('');
	const [selectedPersonRow, setSelectedRowKey] = useState(peopleData[0]?.personID || 0);

	const filteredData = peopleData.filter(
		(object) =>
			object?.displayName?.toLowerCase().includes(searchTerm?.toLowerCase()) ||
			object?.email?.toLowerCase()?.includes(searchTerm?.toLowerCase())
	);

	const columns = [
		{
			title: 'PERSON',
			dataIndex: 'displayName',
			key: 'displayName',
			ellipsis: true,
			width: 40,
			render: (_, record) => <PersonProfileCard inTableUse={true} person={record} highlightOnHover={false} />
		},
		{
			title: 'STATUS',
			dataIndex: '',
			key: 'status',
			ellipsis: true,
			width: 20,
			render: (_, record) => getUserStatus(record)[0]
		},
		{
			title: 'USER TYPE',
			dataIndex: '',
			key: 'userType',
			ellipsis: true,
			width: 20,
			render: (_, record) => {
				return record.userType?.name;
			}
		},
		{
			key: 'ACTION',
			width: 30,
			align: 'center',
			// render: (data) => <PeopleActionDropdown data={data} />,
			ellipsis: true
		}
	];

	return (
		<Row gutter={[10, 10]}>
			<Col xl={24} lg={24} md={24} sm={24} xs={24}>
				<Search
					placeholder='Search Person Name'
					enterButton='Search'
					loading={false}
					onChange={(e) => {
						setSearchTerm(e.target.value);
					}}
					onSearch={(query) => {
						setSearchTerm(query);
					}}
				/>
			</Col>

			<Col xl={17} lg={24} md={24} sm={24} xs={24}>
				<Table
					size='small'
					rowSelection={{
						selectedRowKeys: [selectedPersonRow || peopleData[0]?.personID || 0]
					}}
					scroll={{ x: 'max-content' }}
					columns={columns}
					dataSource={filteredData}
					rowKey={(record) => record.personID}
					onRow={(record) => ({
						onClick: () => {
							setSelectedRowKey(record.personID);
						}
					})}
					loading={loading}
				/>
			</Col>
			<Col xl={7} lg={0} md={0} sm={0} xs={0}>
				<ViewProfileCard personID={selectedPersonRow || peopleData[0]?.personID} />
			</Col>
		</Row>
	);
};

export default PeopleTableInformation;
